export const getTokenWithoutPrefix = (token: string) => {
  if (!token || !token.includes(':')) {
    return token;
  }
  return token.split(':')[1];
};
